import React from 'react';
import styles from './ErrorIcon.module.css';
import { ReactComponent as InfoCircle } from 'assets/InfoCircle.svg';

export const ErrorIcon = () => {
    return (
        <div className={styles.container}>
            <InfoCircle />
        </div>
    );
};
